export const styles = (theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    whiteSpace: 'nowrap',
  },
  coordinates: {
    // Fixed width for the widest possible pair (89.1234° S, 179.1234° W ≈ 161px) so every arrow sits at the same offset.
    minWidth: 165,
  },
  link: {
    color: theme.palette.primary.main,
  },
  empty: {
    color: theme.palette.textColor.secondary,
  },
});
